import React, { PureComponent } from 'react'
import { Layout, message, notification } from 'antd'
import Animate from 'rc-animate'
import { connect } from 'react-redux'
import GlobalHeader from '../components/GlobalHeader'
import TopNavHeader from '../components/TopNavHeader'
import styles from './Header.less'
import { push } from 'connected-react-router'
import Request from '../request'
import moment from 'moment'

const { Header } = Layout

class HeaderView extends PureComponent {
    state = {
        visible: true
    }

    handleMenuClick = ({ key }) => {
        const { dispatch } = this.props

        switch (key) {
            // case 'logout':
            //     Request.checkPendingTaskAndFollowupAtLogout({ logoutTime: moment() }).then((x) => {
            //         if (!x.error) {
            //             localStorage.clear()
            //             notification.success({
            //                 message: x.message
            //             })
            //             setTimeout(() => {
            //                 window.location.href = "/login";
            //             }, 120)
            //         } else {
            //             notification.error({ message: x.msg })
            //         }
            //     })
            //     break

            case 'logout':
                Request.checkPendingTaskAndFollowupAtLogout({ logoutTime: moment() })
                    .then(function (x) {
                        if (x && !x.error) {
                            notification.success({
                                message: x.message ? x.message : "Logged out successfully"
                            });
                        } else {
                            notification.error({
                                message: x && x.msg ? x.msg : "Something went wrong"
                            });
                        }
                    })
                    .catch(function () {
                        // API failed (like 401), still logout user
                        notification.success({
                            message: "Logged out successfully"
                        });
                    })
                    .finally(function () {
                        localStorage.clear();
                        setTimeout(function () {
                            window.location.href = "/login";
                        }, 400); // give time for notification to show
                    });
                break;

            case 'changePassword':
                dispatch(push('/changePassword'))
                break
            case 'updateProfile':
                dispatch(push('/updateProfile'))
                break
            case 'updateBranch':
                dispatch(push('/master/update-branch'))
                break
            default:
                console.log(key, ' this is working')
        }
    }
    handScroll = () => {
        const { autoHideHeader } = this.props
        const { visible } = this.state
        if (!autoHideHeader) {
            return
        }
        const scrollTop =
            document.body.scrollTop + document.documentElement.scrollTop
        if (!this.ticking) {
            this.ticking = true
            requestAnimationFrame(() => {
                if (this.oldScrollTop > scrollTop) {
                    this.setState({
                        visible: true
                    })
                } else if (scrollTop > 300 && visible) {
                    this.setState({
                        visible: false
                    })
                } else if (scrollTop < 300 && !visible) {
                    this.setState({
                        visible: true
                    })
                }
                this.oldScrollTop = scrollTop
                this.ticking = false
            })
        }
    }

    static getDerivedStateFromProps(props, state) {
        if (!props.autoHideHeader && !state.visible) {
            return {
                visible: true
            }
        }
        return null
    }

    getHeadWidth = () => {
        const { isMobile, collapsed } = this.props
        const { fixedHeader, layout } = {}
        if (isMobile || !fixedHeader || layout === 'topmenu') {
            return '100%'
        }
        return collapsed ? 'calc(100% - 80px)' : 'calc(100% - 256px)'
    }

    handleNoticeClear = type => {

    }

    componentWillUnmount() {
        document.removeEventListener('scroll', this.handScroll)
    }

    handleNoticeVisibleChange = visible => {

    }

    componentDidMount() {
        document.addEventListener('scroll', this.handScroll, { passive: true })

        let { dispatch } = this.props
        let user = localStorage.getItem('user')
        user = JSON.parse(user)
        dispatch({
            type: 'SET_CURRENT_USER',
            user
        })
    }

    render() {
        const { isMobile, handleMenuCollapse, theme } = this.props
        const { navTheme, layout, fixedHeader } = theme
        const { visible } = this.state
        const isTop = layout === 'topmenu'
        const width = this.getHeadWidth()

        const HeaderDom = visible ? (
            <Header
                style={{ padding: 0, width }}
                className={fixedHeader ? styles.fixedHeader : ''}>
                {isTop && !isMobile ? (
                    <TopNavHeader
                        theme={navTheme}
                        mode="horizontal"
                        onCollapse={handleMenuCollapse}
                        onNoticeClear={this.handleNoticeClear}
                        onMenuClick={this.handleMenuClick}
                        onNoticeVisibleChange={this.handleNoticeVisibleChange}
                        {...this.props}
                    />
                ) : (
                    <GlobalHeader
                        onCollapse={handleMenuCollapse}
                        onNoticeClear={this.handleNoticeClear}
                        onMenuClick={this.handleMenuClick}
                        onNoticeVisibleChange={this.handleNoticeVisibleChange}
                        {...this.props}
                    />
                )}
            </Header>
        ) : null
        return (
            <Animate component="" transitionName="fade">
                {HeaderDom}
            </Animate>
        )
    }
}

const mapStateToProps = ({ global, theme }) => {
    return {
        currentUser: global.currentUser,
        notices: global.notices,
        theme
    }
}

export default connect(
    mapStateToProps,
    dispatch => {
        return {
            dispatch
        }
    }
)(HeaderView)
